import { render, staticRenderFns } from "./DraggableBulb.vue?vue&type=template&id=1b9c1983"
import script from "./DraggableBulb.vue?vue&type=script&lang=js"
export * from "./DraggableBulb.vue?vue&type=script&lang=js"
import style0 from "./DraggableBulb.vue?vue&type=style&index=0&id=1b9c1983&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports